import React, { Component } from "react";
import "../style/Card.css";
import axios from "axios";
import keys from "../config";
import CardHover from "./CardHover";
import FileSaver from "file-saver";

export class Card extends Component {
  constructor(props) {
    super(props);
    const {
      pieceName,
      composer,
      category,
      filename,
      unAuthFilename
    } = props.pdf;
    // const { titleMode } = this.props;
    this.state = {
      pieceName,
      composer,
      category,
      filename,
      unAuthFilename,
      res: null,
      expand: false
    };
    this.handleClick = this.handleClick.bind(this);
  }
  async handleClick() {
    const { filename, pieceName, composer, category } = this.state;
    this.props.sendTitleToModal(pieceName);
    const url = keys.getMusicUrl;

    const headers = {
      headers: {
        Authorization: localStorage.getItem("token"),
        file: filename
      },
      // our response is friggin huge array full of PDF innards. `arraybuffer` makes that viewable
      responseType: "arraybuffer"
    };
    this.setState({ res: "LOADING" });
    const res = await axios.get(url, headers);
    this.setState({ res: res.status });
    const blob = new Blob([res.data], { type: "application/pdf" });
    const srcForIframe = window.URL.createObjectURL(blob);

    const titles = pieceName.split("/");
    const latinTitle = titles[0].trim();
    const englishTitle = titles[1].trim();

    let composerLastname = composer
      .split(" ")
      .slice(-1)
      .join("")
      .toLowerCase()
      .trim();
    if (
      composerLastname === "pres" ||
      composerLastname === "castro" ||
      composerLastname === "lasso"
    ) {
      // add the `di` or similar
      composerLastname = composer
        .split(" ")
        .slice(-2)
        .join(" ");
    }

    const voicing = category.split(",")[0];

    const nameOfFileWhenDownloaded = `${latinTitle}_${englishTitle}-${composerLastname}-${voicing}`;
    this.props.toggleModal(function() {
      FileSaver.saveAs(blob, nameOfFileWhenDownloaded);
    });
    this.props.iframeSrc(srcForIframe);
  }
  formatCategories(arrayOfCategories) {
    const stringOfCategories = String(arrayOfCategories);
    return stringOfCategories.split(",").join(", ");
  }
  render() {
    const { pieceName, composer, category } = this.state;
    const { titleMode } = this.props;
    // format pieceName
    let piecenameForDisplay = pieceName;
    if (titleMode === "English/Latin") {
      // keep as the original
      piecenameForDisplay = pieceName;
    } else if (titleMode === "English") {
      // display only English titles
      piecenameForDisplay = pieceName.split(" / ")[0];
    } else if (titleMode === "Latin") {
      // display only Latin title
      piecenameForDisplay = pieceName.split(" / ")[1];
    }
    return (
      <div>
        <div>
          {this.state.res === "LOADING" ? (
            <div className="spinner spinner-5">
              <span />
              <span />
              <span />
            </div>
          ) : (
            ""
          )}
        </div>
        <div className="card" onClick={this.handleClick}>
          <div className="card-content">
            <p className="piece-name">
              {piecenameForDisplay}
              &nbsp;(
              {composer})
            </p>
            <CardHover categories={this.formatCategories(category)} />
          </div>
        </div>
      </div>
    );
  }
}

export default Card;



// WEBPACK FOOTER //
// ./src/components/Card.js